import config from "./config";

let logrocketConfig = null;
let sentryConfig = null;

export async function fetchLogrocketConfig() {
    try {
        const res = await fetch(`${config.API_URL}globalConfig/logrocket`);
        if (!res.ok) throw new Error(`logrocket config fetch failed: ${res.status}`);
        logrocketConfig = await res.json();
    } catch (err) {
        console.error("Failed to fetch logrocket config:", err);
        logrocketConfig = { appId: "" };
    }
    return logrocketConfig;
}

export async function fetchSentryConfig() {
    try {
        const res = await fetch(`${config.API_URL}globalConfig/sentry`);
        if (!res.ok) throw new Error(`sentry config fetch failed: ${res.status}`);
        sentryConfig = await res.json();
    } catch (err) {
        console.error("Failed to fetch sentry config:", err);
        sentryConfig = { dsn: "", enabled: false, environment: "", tracesSampleRate: 0.05 };
    }
    return sentryConfig;
}

export function getLogrocketConfig() {
    return logrocketConfig;
}

export function getSentryConfig() {
    return sentryConfig;
}
